<app-edit-header
	class="modal-header"
	cancelTooltip="Cancel"
	[buttonTemplateRef]=""
	[cancelFn]="close"
	[cancelAccessKey]="'w'"
	[title]="'Confirm Deletion'"
	[headerClass]="'w-100 bg-transparent text-primary'"
	[rowClass]="'row'"
></app-edit-header>
<div class="modal-body">
	<p>
		Are you sure you want to delete the following record? <br />
		<span class="text-danger">This cannot be undone.</span>
	</p>
	<div class="card-header">
		<div class="d-flex">
			<div class="card-title d-flex justify-content-between w-100 mb-0">
				<div class="align-self-center">
					<span
						[nstarReference]="listingAudit.modificationUserName"
						[ngbTooltip]="listingAudit?.memberFullName"
						container="body"
						type="member"
						[disabled]="true"
					>
						{{ listingAudit.modificationUserName }}
					</span>
				</div>
				<div class="small text-muted align-self-center">
					{{ listingAudit.modificationTimestampUTCDTTM + "Z" | date : "short" }}
				</div>
			</div>
		</div>
	</div>
	<div class="card-body">
		<app-history-item [historyData]="listingAudit"></app-history-item>
	</div>
</div>
<div class="modal-footer">
	<button class="btn btn-danger" (click)="deleteRecord()">Delete Record</button>
</div>
